// extracted by mini-css-extract-plugin
export default {"submitBtn":"Forms_submitBtn__XwTCN"};